import axios from 'axios';

/**
 * Shared Axios instance. Auth headers and tenant ID are applied globally
 * in AuthContext via axios.defaults.
 */
const axiosInstance = axios;

export default axiosInstance;
